/** @file Studio gallery route for design system token review. */
import { lazy } from 'react';
import Loadable from 'ui-components/loadhandlers/Loadable';

const StudioGallery = Loadable(lazy(() => import('views/studio/StudioGallery')));

const StudioRoutes = {
  path: '/__studio',
  element: <StudioGallery />
};

export default StudioRoutes;
